// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2_SB7","right":"styles_right__2nVeK"};